(function (Drupal) {
  Drupal.behaviors.repositionSidebarAndFooter = {
    attach: function (context) {
      const pageWrapper = context.querySelector("#page-wrapper-with-sidebar");
      const sidebarRegion = context.querySelector(".sidebar_region");
      const deptFooterBlock = context.querySelector("#block-msu-drupal-deptfooterblock");
      const footer = context.querySelector("footer.footer");

      // Function to move the sidebar region below the content region and move the footer block.
      function moveElementsOutOfWrapper() {
        if (sidebarRegion && pageWrapper.contains(sidebarRegion)) {
          pageWrapper.insertBefore(sidebarRegion, null);
        }

        if (deptFooterBlock && pageWrapper.contains(deptFooterBlock)) {
          pageWrapper.parentNode.insertBefore(deptFooterBlock, pageWrapper.nextSibling);
        }

        if (footer && pageWrapper.contains(footer)) {
          pageWrapper.parentNode.insertBefore(footer, deptFooterBlock ? deptFooterBlock.nextSibling : pageWrapper.nextSibling);
        }
      }

      moveElementsOutOfWrapper();

      // Optional: Use a MutationObserver to handle dynamic content changes
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            moveElementsOutOfWrapper();
          }
        });
      });

      observer.observe(pageWrapper, { childList: true, subtree: false });
    }
  };
})(Drupal);
